<section>
  <button type="button" class="btn btn-back d-flex align-items-center py-5" [routerLink]="['/sales-activities']"
    routerLinkActive="router-link-active">
    <img src="assets/icons/arrow-left.png" alt=""> <span class="mx-4">Back</span>
  </button>

  <div class="container-fluid py-4 px-4">
    <div class="container-card mb-4">
      <div class="row align-items-center justify-content-between">
        <!-- Added align-items-center and changed justify-content -->
        <div class="col-12 col-md-4 col-lg-4">
          <div class="d-flex flex-column mb-3">
            <div class="">
              <h1 class="heading-1">{{ SalesDetail?.property_name }}</h1>
            </div>
            <div class="py-2 title">{{ SalesDetail?.contract_no }}</div>
            <div class="title">Est. Contract</div>
            <div class="title-currency">
              {{ (SalesDetail?.est_contract ?? 0) | rupiah }}
            </div>
          </div>
        </div>

        <div class="col-12 col-md-8 col-lg-8"> <!-- Changed col size -->
          <app-progress-step-bar></app-progress-step-bar>
        </div>
      </div>

      <div class="my-4">
        <div class="row">
          <div class="col-12 col-md-12 col-lg-4">
            <div class="card h-100">
              <div class="card-body card-body-custom">
                <h5 class="card-title card-title-custom">
                  <img src="assets/icons/revenue-lease.png"> Property Information
                </h5>

                <div *ngIf="isLoading" class="text-center my-5">
                  <p>Loading detail data...</p>
                </div>

                <div class="container-box-information">
                  <div class="row">
                    <div class="col-6 col-md-6 col-lg-6">
                      <h5 class="title-box">Type</h5>
                    </div>
                    <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                      <h5 class="title-box-bold">{{ SalesDetail?.info?.type }}</h5>
                    </div>
                  </div>
                </div>

                <div class="container-box-information">
                  <div class="row">
                    <div class="col-6 col-md-6 col-lg-6">
                      <h5 class="title-box">Customer Name</h5>
                    </div>
                    <div class="col-6 col-md-6 col-lg-6 text-end">
                      <h5 class="title-box-bold">{{ SalesDetail?.info?.cust_name }}</h5>
                    </div>
                  </div>
                </div>

                <div class="container-box-information">
                  <div class="row">
                    <div class="col-6 col-md-6 col-lg-6">
                      <h5 class="title-box">Floor/Type</h5>
                    </div>
                    <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                      <h5 class="title-box-bold">{{ SalesDetail?.info?.floor }}</h5>
                    </div>
                  </div>
                </div>

                <div class="container-box-information">
                  <div class="row">
                    <div class="col-6 col-md-6 col-lg-6">

                      <div class="d-flex flex-column align-items-start">
                        <h5 class="title-box">Total Leased (Sqm)</h5>
                      </div>

                    </div>
                    <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">

                      <div class="d-flex flex-column align-items-center">
                        <h5 class="title-box-bold">{{ SalesDetail?.info?.total_leased }}</h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="!isLoading && error" class="alert alert-danger">
                  Gagal memuat data: {{ error || 'Unknown error' }}
                </div>



              </div>
            </div>
          </div>

          <div class="col-12 col-md-12 col-lg-5 my-4 my-lg-0">
            <div class="card h-100">
              <div class="card-body card-body-custom">
                <h5 class="card-title card-title-custom">
                  <img src="assets/icons/revenue-lease.png"> Property Financial
                </h5>

                <div class="container-box-information-financial" *ngFor="let item of ItemSalesFinance">
                  <div class="row">
                    <div class="col-6 col-md-6 col-lg-6">
                      <h5 class="title-box">{{ item.title }}</h5>
                    </div>
                    <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                      <h5 class="title-box-bold">{{ item.value | rupiah }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="col-12 col-md-12 col-lg-3">
            <div class="card h-100">
              <div class="card-body card-body-custom">
                <h5 class="card-title card-title-custom">
                  <img src="assets/icons/revenue-lease.png"> Contact Info
                </h5>

                <div class="container-box-information-contact" *ngFor="let item of SalesContactInfo">

                  <div class="d-flex flex-column align-items-start">
                    <h5 class="title-box-contact my-2">{{ item.title }}</h5>
                    <h5 class="title-box-contact my-2">{{ item.contact_name }}</h5>
                  </div>
                  <div class="row">
                    <div class="col-6 col-md-6 col-lg-6">
                      <div class="d-flex flex-column align-items-start">
                        <h5 class="title-box-bold my-2">{{ item.contact_no | phoneFormat }}</h5>
                      </div>
                    </div>
                    <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                      <div class="d-flex flex-column align-items-center">
                        <img src="assets/icons/phone-call.png" alt="" style="width: 25px; height: 25px;">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="table-responsive my-3 p-0 d-none d-lg-block">
        <table class="table table-striped text-nowrap">
          <thead>
            <tr>
              <th class="text-center sortable-header" (click)="onSort('trans_date')">
                <span>Date</span>
                <i [class]="getSortIcon('trans_date')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('activity')">
                <span>Activity</span>
                <i [class]="getSortIcon('activity')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('price')">
                <span>Price</span>
                <i [class]="getSortIcon('price')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('sales')">
                <span>Sales</span>
                <i [class]="getSortIcon('sales')" class="sort-icon"></i>
              </th>
            </tr>

          </thead>
          <tbody *ngIf="!isLoading && itemSalesList.length > 0">
            <tr *ngFor="let item of itemSalesList">
              <td class="text-center">{{ item.trans_date | dateformat }}</td>
              <td class="text-center">{{ item.activity }}</td>
              <td class="text-end">{{ item.price | rupiah }}</td>
              <td class="text-center">{{ item.sales }}</td>
            </tr>

          </tbody>
          <tbody *ngIf="isLoading">
            <tr>
              <td colspan="4" class="text-center">
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="my-4 d-block d-lg-none">

        <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}" role="button"
          *ngFor="let item of itemSalesList; let i = index">
          <div class="card-header card-sm-header">
            <h5>{{ item.trans_date | dateformat }}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-5">
                <div class="card-sm-title mt-2">Activity</div>
                <div class="card-sm-title mt-2">Price</div>
                <div class="card-sm-title mt-2">Sales</div>
              </div>
              <div class="col-7">
                <div class="card-sm-title mt-2">{{ item.activity }}</div>
                <div class="card-sm-title mt-2">{{ item.price | rupiah }}</div>
                <div class="card-sm-title mt-2">{{ item.sales }}</div>
              </div>
            </div>
          </div>

          <div class="card-body d-flex justify-content-center" *ngIf="isLoading">
            <div class="spinner-border text-success text-center" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-start total-page-number">
          <h5 class="pageCount">
            Displaying
            <span class="fw-bold">{{ displayRange.start | number }}</span> -
            <span class="fw-bold">{{ displayRange.end | number }}</span>
            out of
            <span class="fw-bold">{{ displayRange.total | number }}</span>
          </h5>
        </div>
        <div
          class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-end justify-content-end page-pagination">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link first-page" href="javascript:void(0)" (click)="onFirstPage()" aria-label="First">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link prev-page" href="javascript:void(0)" (click)="onPrevPage()" aria-label="Previous">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item" *ngFor="let page of pageNumbers"
                [class.active]="page === paginationConfig.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(page)">{{ page }}</a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link next-page" href="javascript:void(0)" (click)="onNextPage()" aria-label="Next">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link last-page" href="javascript:void(0)" (click)="onLastPage()" aria-label="Last">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

    </div>
  </div>

</section>
